import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcMask from '@/components/Mask.vue';
import BcTable from '@/components/Table.vue';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import Autocomplete from '../devCheck/components/Autocomplete.vue';
import DeviceInfoCard from './components/DeviceInfoCard.vue';
import CustomTimeLine from './components/CustomTimeLine.vue';
import DeviceTimeLine from './components/DeviceTimeLine.vue';
// @ts-ignore
let Project = class Project extends Vue {
    constructor(props) {
        super(props);
        this.snackbar = new CBcSnackbar();
        /* 查看的视图类型 table|timeline */
        this.viewType = 'timeline';
        this.searchParams = {
            customerName: null,
            finalUser: null,
            customerAddr: null,
        };
        this.existCustomName = [];
        this.finalUsers = [];
        this.customerAddr = [];
        this.statusLists = [];
        this.menuDateRange = {
            visible: false,
            dateRange: [],
            events: [],
        };
        this.currentStatus = null;
        /* 表格视图相关 */
        this.tableHeader = [
            {
                text: '序号',
                align: 'center',
                sortable: false,
                value: 'id',
            },
            {
                text: '客户名称',
                align: 'center',
                sortable: false,
                value: 'customerName',
            },
            {
                text: '订单类型',
                align: 'center',
                sortable: false,
                value: 'orderType',
            },
            {
                text: '营销时间',
                align: 'center',
                sortable: false,
                value: 'time',
            },
            {
                text: '终端用户',
                align: 'center',
                sortable: false,
                value: 'finalUser',
            },
            {
                text: '省份',
                align: 'center',
                sortable: false,
                value: 'customerAddr',
            },
            {
                text: '售后负责人',
                align: 'center',
                sortable: false,
                value: 'afterSaleSupport',
            },
            {
                text: '订单状态',
                align: 'center',
                sortable: false,
                value: 'orderStatus',
                filter: (value) => value.slice(0, 1),
            },
            {
                text: '回款进度',
                align: 'center',
                sortable: false,
                value: 'remittance',
            },
            {
                text: '产品列表',
                align: 'center',
                sortable: false,
                value: 'orderList',
            },
            {
                text: '操作',
                align: 'center',
                sortable: false,
                value: 'action',
            },
        ];
        this.row = null;
        this.tableData = [];
        this.pagination = {
            visible: true,
            total: 1,
            pageSize: 10,
            page: 1,
            expanded: []
        };
        /* 时间轴视图相关 */
        this.orderCustomers = [];
        this.orderFinalUsers = [];
        this.customList = [];
        this.panelsModel = [];
        this.collabHistory = [];
        this.orderDeviceList = [];
        this.showDeviceList = [];
        this.customerInfo = {};
        this.customDepartment = [];
        this.currentDepe = 0;
        this.depeList = [];
        this.selectDept = [];
        this.showCustom = {};
        this.allDeviceList = [];
        /* 弹窗相关 */
        this.dialogInfo = {};
        this.srcDialogInfo = {};
        this.deviceList = [];
        this.optionalDeviceList = [];
        this.selectDeviceList = [];
        this.dialog = {
            title: '项目历程详细',
            text: '',
            visible: false,
            loading: false,
        };
        this.timelineShow = 'custom';
        this.showHistoryDevice = {};
        this.selectDevice = [];
        this.deviceSelectList = [];
        this.customFilter = [];
    }
    selectDate(date) {
        const that = this;
        if (date.length >= 2) {
            that.menuDateRange.visible = false;
        }
    }
    autoCmpChanged(type, value) {
        if (type == 'customerName') {
            this.searchParams.customerName = value && value.customerName || null;
        }
        else if (type == 'finalUser') {
            this.searchParams.finalUser = value && value.name || null;
        }
        else if (type == 'customerAddr') {
            this.searchParams.customerAddr = value && value.name || null;
        }
    }
    pageItemChange(val) {
        if (val === 1) {
            this.viewType = 'timeline';
        }
        else {
            this.viewType = 'table';
            this.searchData();
        }
    }
    getStatusColor(item) {
        let color = 'rgb(135, 206, 235, 1)';
        switch (item.orderStatus) {
            case '验收':
                {
                    color = 'rgba(67, 207, 124, 1)';
                }
                break;
            case '确认':
                {
                    color = 'rgba(67, 205, 128, 0.7)';
                }
                break;
            case '生产':
            case '出库':
                {
                    color = 'rgba(0, 191, 255, 0.7)';
                }
                break;
            case '开票':
            case '发货-出':
            case '收货-出':
                {
                    color = 'rgba(30, 144, 255, 1)';
                }
                break;
            case '售后':
                {
                    color = 'rgba(0, 184, 255, 0.7)';
                }
                break;
            case '取消':
            case '退回':
            case '拒绝':
                {
                    color = 'rgba(255, 48, 48, 0.5)';
                }
                break;
            default: break;
        }
        return color;
    }
    getStepText(item, type) {
        let str = (type == 'last' ? item.lastData : item.currentData) || '';
        const txtType = item.stepText || item.stepName || '';
        if (/设备/.test(txtType)) {
            const listStr = (type == 'last' ? item.lastData : item.currentData) || '[]';
            const list = JSON.parse(listStr);
            const devList = list.map((it) => it.name || '');
            str = devList.join(',');
        }
        return str;
    }
    departmentFilter(idx) {
        let depe = null;
        if (idx > 0) {
            depe = this.customDepartment[idx - 1];
        }
        this.showDeviceList = this.orderDeviceList;
        if (depe) {
            this.showDeviceList = this.orderDeviceList.filter((it) => it.department == depe);
        }
    }
    customClicked(val) {
        this.showCustom = val;
        this.customCollaHistory();
    }
    async editCardOrBrowse(val = null) {
        if (val && val.id) {
            this.showCustom = val;
            await this.customCollaHistory();
        }
        this.dialog.visible = true;
    }
    getOptionalDeviceList(order = {}) {
        let list = [];
        if (order && order.orderNumber) {
            const modeList = (order.deviceList || []).map((v) => v.mode);
            list = this.allDeviceList.filter((it) => modeList.includes(it.mode) && (!it.associateOrder || it.associateOrder == order.orderNumber || it.associateOrder == ''));
        }
        return list;
    }
    dialogSelectDevice(deviceInfo) {
        // console.log('select device: ', deviceInfo)
        if (!deviceInfo.bind) {
            this.snackbar.warn('该订单未关联设备哦!');
            return;
        }
        this.timelineShow = 'device';
        this.showHistoryDevice = deviceInfo;
    }
    onSelectDeptChange(value) {
        if (value == 0) {
            this.customFilter = [];
        }
        else {
            this.customFilter = this.selectDept[value - 1];
        }
    }
    closeDialog() {
        this.dialog.visible = false;
    }
    /* 遍历获取变更的key信息，简化上传 */
    deepCompare(obj1 = {}, obj2 = {}, path = '') {
        let changes = []; // 用来存储发生变化的键的路径
        if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
            if (obj1 !== obj2) {
                changes.push(path);
            }
            return changes;
        }
        const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
        keys.forEach((key) => {
            const newPath = path ? `${path},${key}` : key;
            if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
                changes = changes.concat(this.deepCompare(obj1[key], obj2[key], newPath));
            }
        });
        return changes;
    }
    getProducts() {
        const list = [];
        // console.log(' src data: ', JSON.stringify(this.srcDialogInfo))
        this.dialogInfo.orders.forEach((it) => {
            const deviceList = it.deviceList || [];
            const orderModeList = it.deviceList.map((v) => v.mode).filter((v) => v);
            deviceList.forEach((deviceId) => {
                /* 新增部分 */
                if (typeof deviceId === 'string' || typeof deviceId === 'number') {
                    const device = this.allDeviceList.find((_it) => _it.deviceId == deviceId && orderModeList.includes(_it.mode));
                    if (device) {
                        const item = list.find((_it) => _it.id == it.id);
                        if (!item) {
                            list.push({
                                id: it.id,
                                deviceInfoIdList: [device.id],
                                needUpdate: true,
                            });
                        }
                        else {
                            item.deviceInfoIdList.push(device.id);
                        }
                    }
                }
                else {
                    // console.log(' ----deviceinfo: ', JSON.stringify(deviceId))
                }
            });
        });
        this.srcDialogInfo.orders.forEach((it, index) => {
            const deviceList = it.deviceList || [];
            deviceList.forEach((device) => {
                if (device.bind) {
                    const idDeleted = this.dialogInfo.orders[index].deviceList.find((v) => v.deviceId == device.deviceId || v == device.deviceId);
                    if (!idDeleted) { /* 该元素被移除了 */
                        const { id } = it;
                        const item = list.find((_it) => _it.id == id);
                        if (!item) {
                            list.push({
                                id: id,
                                deviceInfoIdList: [],
                                needUpdate: true,
                            });
                        }
                    }
                }
            });
        });
        return list;
    }
    getCoustomUpdateList() {
        let list = [];
        const changeKeys = this.deepCompare(this.srcDialogInfo, this.dialogInfo);
        if (changeKeys && changeKeys.length) {
            const pubInfo = {};
            const orderInfo = [];
            changeKeys.forEach((key) => {
                if (key.startsWith('orders')) { /* 单个订单消息 */
                    const keyArr = key.split(',');
                    /* 1. orders;2. 订单信息; 3,修改字段 */
                    if (keyArr.length > 2 && !key.includes('deviceList')) {
                        const it = this.dialogInfo.orders[keyArr[1]];
                        const upKey = keyArr[2];
                        const idx = it.id;
                        if (idx) {
                            let fItem = orderInfo.find((v) => v.id == idx);
                            if (!fItem) {
                                fItem = {
                                    id: idx,
                                    [upKey]: it[upKey],
                                };
                                orderInfo.push(fItem);
                            }
                            else {
                                fItem[upKey] = it[upKey];
                            }
                        }
                    }
                }
                else if (!key.includes(',')) { /* 客户信息 */
                    pubInfo[key] = this.dialogInfo[key];
                }
            });
            const pKeys = Object.keys(pubInfo);
            if (pKeys.length) {
                const orderList = this.dialogInfo.orders.map((v) => ({ id: v.id }));
                list = list.concat(orderList).map((v) => ({ ...v, ...pubInfo }));
            }
            if (orderInfo.length) {
                orderInfo.forEach((v) => {
                    const idx = v.id;
                    if (idx) {
                        const it = list.find((_it) => _it.id == idx);
                        if (it) {
                            const ks = Object.keys(v);
                            ks.forEach((_k) => {
                                if (_k != 'id') {
                                    it[_k] = v[_k];
                                }
                            });
                        }
                    }
                });
            }
        }
        return list;
    }
    async accept() {
        /* 准备提交和保存信息 */
        const list = this.getCoustomUpdateList();
        const deviceList = this.getProducts();
        // console.log(' -update list-: ', JSON.stringify(deviceList))
        for (let i = 0; i < list.length; i++) {
            const it = list[i];
            if (it && it.id) {
                const params = { ...it };
                delete params.id;
                await this.axios.put('/api/project/order/' + it.id, params).catch((err) => {
                });
            }
        }
        for (let i = 0; i < deviceList.length; i++) {
            const it = deviceList[i];
            if (it.id) {
                const deviceIdList = JSON.stringify(it.deviceInfoIdList);
                const params = { deviceInfoIdList: deviceIdList };
                await this.axios.put('/api/project/order/associate/device/' + it.id, params).catch((err) => {
                });
            }
        }
        /* 对比变更 */
        this.dialog.visible = false;
        await this.getInitData();
    }
    async getInitData() {
        await this.getAllDeviceState();
        this.searchData(true);
        this.getOrderDict();
    }
    /* 获取所有设备信息 */
    async getAllDeviceState() {
        await this.axios.get('/api/project/device/state', { params: {} })
            .then((res) => {
            const result = res.data && res.data.result || [];
            this.allDeviceList = result;
            // console.log(' device list: ', JSON.stringify(result))
        })
            .catch((err) => this.snackbar.error('获取设备信息失败!'));
    }
    async searchData(custom = false) {
        const p = { ...this.searchParams };
        if (this.currentStatus && this.currentStatus.length) {
            p.statusList = JSON.stringify(this.currentStatus);
        }
        if (this.menuDateRange.dateRange && this.menuDateRange.dateRange.length) {
            let start = new Date(this.menuDateRange.dateRange[0]);
            let end = new Date();
            if (this.menuDateRange.dateRange.length > 1) {
                let s = start;
                let e = this.menuDateRange.dateRange[1];
                if (new Date(s) > new Date(e)) {
                    const t = s;
                    s = e;
                    e = t;
                }
                start = s;
                end = e;
            }
            p.time = JSON.stringify([new Date(start).format('yyyy-MM-dd'), new Date(end).format('yyyy-MM-dd')]);
        }
        if (this.viewType == 'timeline') {
        }
        else {
            this.getOrderList(p);
        }
        if (custom) {
            this.getCustomList(p);
        }
    }
    async getOrderList(params = {}) {
        const p = { ...params };
        await this.axios.get('/api/project/order', { params: p })
            .then((res) => {
            const info = res.data || {};
            const result = res.data && res.data.result || [];
            this.tableData = result;
            this.pagination.total = info.total || 0;
            this.pagination.page = info.page || 1;
            if (info.limit) {
                this.pagination.pageSize = info.limit;
            }
        })
            .catch((err) => this.snackbar.error('获取项目数据失败!'));
    }
    async getCustomList(params = {}) {
        const p = { ...params };
        await this.axios.get('/api/project/order/customer', { params: p })
            .then((res) => {
            const result = res.data && res.data.result || [];
            this.orderCustomers = result;
            this.customList = [];
            this.orderFinalUsers = [];
            this.customerAddr = [];
            this.orderCustomers.forEach((item) => {
                const it = this.customList.find((v) => v.customerName == item.customerName);
                if (!it) {
                    const pIt = {
                        customerName: item.customerName,
                        finalUsers: []
                    };
                    if (item.finalUser) {
                        pIt.finalUsers.push(item.finalUser);
                    }
                    this.customList.push(pIt);
                }
                else {
                    if (item.finalUser) {
                        it.finalUsers.push(item.finalUser);
                    }
                }
                if (item.finalUser && !this.orderFinalUsers.includes(item.finalUser)) {
                    this.orderFinalUsers.push(item.finalUser);
                }
                if (item.customerAddr && !this.customerAddr.includes(item.customerAddr)) {
                    this.customerAddr.push({ name: item.customerAddr, });
                }
            });
            this.existCustomName = [...this.customList];
            this.finalUsers = this.orderFinalUsers.map((item) => ({ name: item }));
        })
            .catch((err) => this.snackbar.error('获取客户数据失败!'));
    }
    getDeviceColor(device) {
        const status = device.bind ? device.deviceInfo && device.deviceInfo.deviceStatus || '未绑定' : '未绑定';
        switch (status) {
            case '正常':
                return 'primary';
            case '返修':
                return 'secondary';
            case '故障':
                return 'error';
            case '停用':
                return 'warning';
            default:
                return 'gray';
        }
    }
    async customCollaHistory() {
        const customName = this.showCustom && this.showCustom.customerName;
        if (customName) {
            const p = { equalName: customName };
            this.orderDeviceList = [];
            this.collabHistory = [];
            this.customerInfo = {
                customerName: null,
                customerAddr: null,
                detailsAddr: null,
                remark: null,
                time: null,
                finalUsers: [],
                department: [],
                liaison: [],
                charge: [],
                salers: [],
                orders: [],
            };
            this.customDepartment = [];
            this.deviceList = [];
            await this.axios.get('/api/project/order/history', { params: p })
                .then((res) => {
                const result = res.data && res.data.result || [];
                result.forEach((order) => {
                    const records = order.records || [];
                    const title = { ...order, type: 'title' };
                    title.orderList = (order.orderList && order.orderList.length) ? order.orderList.join(',') : '';
                    delete title.records;
                    /* 对设备进行关联 */
                    const orderDevice = (order.orderList || []).map((v) => ({
                        bind: false,
                        mode: v,
                        department: order.department,
                        orderNumber: order.orderNumber,
                    }));
                    if (order.productList && order.productList.length) {
                        order.productList.forEach((pro) => {
                            const { mode } = pro;
                            let it = orderDevice.find((v) => v.mode == mode && !v.bind);
                            if (it) {
                                /* 实际设备的新动态 */
                                const dev = this.allDeviceList.find((v) => v.id == pro.id);
                                // console.log('device info: ', JSON.stringify(dev), JSON.stringify(pro))
                                it = Object.assign(it, {
                                    ...pro,
                                    ...dev,
                                    bind: true,
                                });
                                // console.log('device info: ', JSON.stringify(it))
                            }
                        });
                    }
                    // console.log('products device list: ', JSON.stringify(order.productList))
                    const orderInfo = {
                        orderNumber: order.orderNumber || null,
                        saler: order.saler || null,
                        saleTime: order.time ? new Date(order.time).format('yyyy-MM-dd') || null : null,
                        remittance: order.remittance || 0,
                        department: order.department || null,
                        detailsAddr: order.detailsAddr || null,
                        id: order.id || null,
                        liaison: order.liaison || null,
                        deviceList: [...orderDevice],
                    };
                    this.orderDeviceList = this.orderDeviceList.concat([...orderDevice]);
                    this.customerInfo.orders = this.customerInfo.orders.concat(orderInfo);
                    this.collabHistory.push(title);
                    records.forEach((rec) => {
                        this.collabHistory.push(rec);
                    });
                    if (!this.customerInfo.customerName) {
                        this.customerInfo.customerName = order.customerName;
                    }
                    if (!this.customerInfo.customerAddr) {
                        this.customerInfo.customerAddr = order.customerAddr;
                    }
                    if (!this.customerInfo.detailsAddr) {
                        this.customerInfo.detailsAddr = order.detailsAddr;
                    }
                    if (!this.customerInfo.time || new Date(this.customerInfo.time) > new Date(order.time)) {
                        this.customerInfo.time = order.time;
                    }
                    if (order.finalUser && !this.customerInfo.finalUsers.includes(order.finalUser)) {
                        this.customerInfo.finalUsers.push(order.finalUser);
                    }
                    if (order.department && !this.customerInfo.department.includes(order.department)) {
                        this.customerInfo.department.push(order.department);
                        this.customDepartment.push(order.department);
                    }
                    if (order.liaison && !this.customerInfo.liaison.includes(order.liaison)) {
                        this.customerInfo.liaison.push(order.liaison);
                    }
                    if (order.charge && !this.customerInfo.charge.includes(order.charge)) {
                        this.customerInfo.charge.push(order.charge);
                    }
                    if (order.saler && !this.customerInfo.salers.includes(order.saler)) {
                        this.customerInfo.salers.push(order.saler);
                    }
                });
                this.showDeviceList = this.orderDeviceList;
                this.currentDepe = 0;
                this.dialogInfo = this.customerInfo;
                this.depeList = [];
                (this.dialogInfo.orders || []).forEach((order) => {
                    if (!this.depeList.includes(order.department)) {
                        this.depeList.push(order.department);
                        this.selectDept.push(order.department);
                    }
                    (order.deviceList || []).forEach((device) => {
                        // this.deviceSelectList.push(device.deviceId);
                        // if (device.bind) {
                        //   this.deviceSelectList.push(device.deviceId);
                        // }
                        this.deviceList.push(device);
                    });
                    // console.log('device list: ', JSON.stringify(this.deviceList))
                });
                // console.log(' src data info: ', JSON.stringify(this.dialogInfo))
                this.srcDialogInfo = JSON.parse(JSON.stringify(this.dialogInfo));
            })
                .catch((err) => this.snackbar.error('获取合作历史失败!'));
        }
    }
    async getOrderDict() {
        const p = {};
        await this.axios.get('/api/project/order/dict', { params: p })
            .then((res) => {
            this.statusLists = res.data && res.data.result || [];
        })
            .catch((err) => this.snackbar.error('获取订单字典失败!'));
    }
    async created() {
        this.getInitData();
    }
};
Project = __decorate([
    Component({
        name: 'Project',
        components: {
            BcTable,
            Autocomplete,
            DeviceInfoCard,
            CustomTimeLine,
            DeviceTimeLine,
            BcMask,
            BcSnackbar,
        },
        filters: {
            dateFormat(date) {
                if (!date)
                    return '';
                const dates = new Date(date);
                return dates.format('yyyy-MM-dd');
            }
        }
    })
], Project);
export default Project;
